import { Endpoint } from '../endpoint';
import { CompactProgramsResponse, ProgramResponse, ProgramId } from '@business/entities/programs';
import { CompanyId } from '@business/entities/companies';
import { ProgramsFilterData } from '@modules/programs/ProgramsPage/ProgramsPage';
import { R } from '@core/utils/r';

export function fetchPrograms(filter?: ProgramsFilterData, isCompact?: boolean) {
  const params = R.objectCompact({ ...filter, isCompact });
  return Endpoint.get<CompactProgramsResponse[]>(`@makh/programs`, { params });
}

export function fetchProgram(id: ProgramId) {
  return Endpoint.get<ProgramResponse>(`@makh/programs/program/${id}`);
}

export function createPrograms(data: Partial<ProgramResponse>) {
  return Endpoint.post<ProgramResponse>(`@makh/programs`, { data });
}

export function updatePrograms(programId: ProgramId, data: Partial<ProgramResponse>) {
  return Endpoint.patch<ProgramResponse>(`@makh/programs/${programId}`, { data });
}

export function updateProgramDate(programId: ProgramId, date: number) {
  return Endpoint.get<ProgramResponse>(`@makh/programs/program-date/${programId}/${date}`);
}

export function updateProgramStatus(programId: ProgramId, status: string) {
  return Endpoint.get<ProgramResponse>(`@makh/programs/program-status/${programId}/${status}`);
}

export function deletePrograms(programId: ProgramId) {
  return Endpoint.delete<void>(`@makh/programs/${programId}`);
}

export function archiveProgram(programId: ProgramId) {
  return Endpoint.patch<ProgramResponse>(`@makh/programs/archive-program/${programId}`);
}
